<template>
  <div class="tabs">
    <div class="tabs-wrapper d-flex flex-column-reverse flex-md-row mb-4">
      <div class="tabs-container">
        <b-tabs active-nav-item-class="active-tab-nav" v-model="tabIndex">
          <b-tab v-for="tab in tabs" :key="tab.id" :title="tab.title"></b-tab>
        </b-tabs>
      </div>
      <div v-if="createTeam" class="btn-container">
        <b-button
          variant="link"
          :href="`teams/create`"
          class="
            create-team-btn
            mb-4 mb-md-0
            w-100
            btn-fillsecondary
            text-decoration-none
          "
        >
          <span>{{ getTrans("label.create_a_team") }}</span>
        </b-button>
      </div>
    </div>
    <div v-if="tabSearch" class="w-100 d-lg-flex">
      <div class="d-lg-flex team-search-container">
        <div class="teams-search mb-3 w-100">
          <b-form-input
            class="w-100"
            v-model="searchTerm"
            @input="debouncedSearch"
            :placeholder="placeholder"
          >
          </b-form-input>
          <i class="search-icon">
            <img
              :src="require('@assets/images/new-icons/search.svg')"
              :alt="null"
              width="20"
              height="20"
            />
          </i>
        </div>
        <p>
          <span class="team-count-found fw-bold">{{ searchCount }}</span>
          <span class="font-weight-normal"> {{ totalResultText }}</span>
        </p>
      </div>
      <b-col
        v-if="!isActivity"
        class="d-flex justify-content-end filter-container pr-0"
      >
        <div class="teams-dropdown">
          <AppCustomDropdown
            :optionList="sortByOptions"
            :defaultText="sortByDefault"
            translationEnable="true"
            @updateCall="updateSortTitle"
          />
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
import AppCustomDropdown from "../components/AppCustomDropdown";
import { debounce } from "lodash";
export default {
  name: 'TabNavigation',
  components: {
    AppCustomDropdown,
  },
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    tabSearch: Boolean,
    createTeam: Boolean,
    searchCount: Number,
    isActivity: Boolean,
  },
  data() {
    return {
      searchTerm: '',
      tabIndex: 0,
      sortByOptions: [
        ['asc::name', 'a_to_z'],
        ['desc::name', 'z_to_a'],
        ['desc::created_at', 'newest'],
        ['asc::created_at', 'oldest'],
      ],
      sortByDefault: this.getTrans('label.sort_by'),
      placeholder: '',
      storedData: ''
    };
  },
  watch: {
    tabIndex(newVal) {
      this.searchTerm = '';
      this.$emit('tabIndexChange', newVal);

      //Save the index of tab to localstorage
      if(this.createTeam){
        localStorage.setItem('navTabIndex', JSON.stringify(newVal));
      }
    },
  },
  methods: {
    debouncedSearch: debounce(function () {
      this.$emit('search', this.searchTerm);
    }, 500),

    updateSortTitle(value) {
      this.$emit('sortBy', value);
      this.sortByDefault = value.selectedVal;
    },
  },
  created() {
    if (this.isActivity) {
      this.placeholder = this.getTrans('placeholder.search_by_name');
    } else {
      this.placeholder = this.getTrans('placeholder.search_team');
    }

    //handle tabs on create
      const storedData = localStorage.getItem('navTabIndex');
      this.storedData = storedData ? JSON.parse(storedData) : '';
    // Only let the navTabindex mutation here
      if(this.$route.name === 'teamPage'){
        this.tabIndex = parseInt(this.storedData, 10);
      }
  },
  computed:{
    totalResultText() {
      const newVal = this.searchCount;
      if (this.isActivity) {
         const totalResultText =
          newVal > 1
            ? this.getTrans('label.activities_found')
            : this.getTrans('label.activity_found');

            return totalResultText;
      } else {
        const totalResultText =
          newVal > 1
            ? this.getTrans('label.teams_found')
            : this.getTrans('label.team_found');

            return totalResultText;
      }
    },
  }
};
</script>

<style lang='scss' scoped>
//tab design
.tabs-container {
  width: 100%;
  padding-right: 10px;
}

//search input

.team-search-container {
  .teams-search {
    position: relative;
    min-width: 327px;
    height: 40px;
    input {
      border: 1px solid #afafaf;
      border-radius: 8px;
      padding-left: 39px;
    }
    .search-icon {
      position: absolute;
      top: 11px;
      left: 12px;
      z-index: 1;
    }
  }

  p {
    min-width: 150px;
    max-width: 186px;
    font-size: 16px;
    color: #0f224d;
    margin-left: 14px;
    margin-top: 7px;
    span {
      font-weight: 700;
    }
  }
}

//create team button
.create-team-btn {
  padding: 8px 24px;
  min-width: 155px;
  height: 40px;
  background: linear-gradient(272.95deg, #3f75e5 2.6%, #32a0f0 94.57%);
  border-radius: 50px;
  border: none;
}
</style>

<style lang="scss">
// fix for conflict in using tabs custom style in scoped css
.tabs-container {
  width: 100%;
  padding-right: 10px;
  .active-tab-nav {
    border: #fff !important;
    border-bottom: 2px solid #1b86d5 !important;
    background: #eaf6fd !important;
    font-weight: 700;
    color: #0e6ad7 !important;
    border-radius: 8px 8px 0px 0px !important;
  }

  //Extra small devices (phones, 600px and down)
  @media only screen and (max-width: 600px) {
    .nav-item {
      width: 50%;
      height: 50%;
      text-align: center;
      font-size: 16px;
    }
    .team-search-container {
      p {
        margin-left: 0 !important;
      }
    }
  }
  // Small devices (portrait tablets and large phones, 600px and up)
  @media only screen and (min-width: 600px) {
    .nav-link {
      width: 159px;
      height: 44px;
      text-align: center;
      font-size: 16px;
    }
  }
}

@media only screen and (max-width: 991px) {
  .filter-container {
    margin-top: -50px;
    padding: 0 !important;
  }
}
</style>
